var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "home-collection-gallery",
      style: _vm.styles,
      attrs: { href: _vm.link }
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("super-image", {
            key: _vm.idx,
            staticClass: "background",
            attrs: {
              src: _vm.cleanImages[_vm.idx],
              color: "#f1f1f1",
              "fill-space": ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.cleanImages, function(url) {
        return _c("img", {
          staticClass: "preload",
          staticStyle: { display: "none" },
          attrs: { src: url }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }